import * as React from 'react';

export const Highlight = ({
  text,
  query,
}: {
  text?: string | null;
  query?: string | null;
}) => {
  if (!text) {
    return null;
  }
  if (!query) {
    return <>{text}</>;
  }

  const queryRegex = new RegExp(`(${query})`, 'i');
  const splitText = text.split(queryRegex);
  return (
    <>
      {splitText.map((chunk, i) =>
        queryRegex.test(chunk) ? (
          // eslint-disable-next-line react/no-array-index-key
          <mark className="bg-yellow-light" key={`${chunk}-${i}`}>
            {chunk}
          </mark>
        ) : (
          chunk
        ),
      )}
    </>
  );
};
